import { Skeleton, Stack } from "@mui/material";
import type { FC } from "react";
import { DashboardDetailRowSkeleton } from "web_myplann/Dashboard/Components/DashboardDetailRowSkeleton";

type Props = {
	cards?: number;
	rowsPerCard?: number;
	withHeader?: boolean;
};

export const DashboardDetailSkeleton: FC<Props> = ({
	cards = 1,
	rowsPerCard = 4,
	withHeader = false,
}) => {
	const cardKeys = Array.from(
		{ length: Math.max(cards, 1) },
		(_, cardIndex) => `card-${cardIndex}`,
	);
	const rowKeys = Array.from(
		{ length: rowsPerCard },
		(_, rowIndex) => `row-${rowIndex}`,
	);

	return (
		<Stack pt={0.8} pb={2} gap={0.8}>
			{cardKeys.map((cardKey) => (
				<Stack key={cardKey} bgcolor="background.paper">
					{withHeader && (
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-between"
							px={1.6}
							py={1.2}
						>
							<Skeleton variant="rounded" width={110} height={18} />
							<Skeleton variant="rounded" width={80} height={14} />
						</Stack>
					)}
					{rowKeys.map((rowKey, index) => (
						<DashboardDetailRowSkeleton
							key={`${cardKey}-${rowKey}`}
							isLast={index === rowKeys.length - 1}
						/>
					))}
				</Stack>
			))}
		</Stack>
	);
};
